// extracted by mini-css-extract-plugin
export default {"input":"linkStyles_input__tN+cR","inputInvalid":"linkStyles_inputInvalid__Ygtdw","link":"linkStyles_link__IdA9y"};